export const COMPANY_WEBSITES_FALLBACK_ERROR = "Could not save company websites. Please try again.";

/** True only for an absolute http(s) URL — the shape the account API accepts. */
export function isHttpWebsiteUrl(value) {
  if (typeof value !== "string" || !value.trim()) {
    return false;
  }
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

/**
 * ER-10219: split a pasted block into website URLs.
 * Accepts whitespace, comma and semicolon separators, keeps the first
 * occurrence of each URL, and reports tokens that are not http(s).
 */
export function parseWebsiteUrls(input) {
  const tokens = String(input || "")
    .split(/[\s,;]+/)
    .map((token) => token.trim())
    .filter(Boolean);

  const urls = [];
  const invalid = [];
  tokens.forEach((token) => {
    if (!isHttpWebsiteUrl(token)) {
      invalid.push(token);
      return;
    }
    if (!urls.includes(token)) {
      urls.push(token);
    }
  });

  return { urls, invalid };
}

function flattenMessages(value) {
  if (typeof value === "string") {
    return value.trim() ? [value.trim()] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(flattenMessages);
  }
  if (value && typeof value === "object") {
    return Object.values(value).flatMap(flattenMessages);
  }
  return [];
}

/** Inline API validation message for the `company_websites` account field. */
export function getCompanyWebsitesErrorMessage(error) {
  const data = error?.response?.data;
  const messages = flattenMessages(data?.company_websites ?? data?.detail);
  return messages.length ? messages.join(" ") : COMPANY_WEBSITES_FALLBACK_ERROR;
}
/**
 * ER-12781: per-website scan status from the account read, keyed by website URL:
 * `{ [url]: { status: "scanning" | "scanned" | "unreachable", last_scanned_at } }`.
 * Anything else (missing field, wrong shape) is treated as "no status known".
 */
export const COMPANY_WEBSITE_SCAN_STATUS_FIELD = "company_website_scan_status";

export function getCompanyWebsiteScanStatuses(accountData) {
  const statuses = accountData?.[COMPANY_WEBSITE_SCAN_STATUS_FIELD];
  return statuses && typeof statuses === "object" && !Array.isArray(statuses) ? statuses : {};
}
